var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.exibeTesteGratis &&
    !_vm.getAcessoModulo({ user: _vm.user, modulo: _vm.SALVAR_DIETA }) &&
    !_vm.user.testou_premium &&
    ((_vm.user.plano !== null && _vm.user.plano.id_empresa === null) ||
      _vm.user.plano === null)
  )?_c('v-flex',{staticStyle:{"opacity":"0.7"},attrs:{"xs12":""},on:{"click":_vm.testePremium}},[_c('v-btn',{staticStyle:{"margin-bottom":"15px","border-radius":"10px","width":"600px","height":"65px"},attrs:{"rounded":"","color":"#008000","dark":""}},[_c('span',{staticStyle:{"font-weight":"600","padding":"4px","font-size":"18px"}},[_vm._v("\n      "+_vm._s(_vm.strings[_vm.idioma].experimente_gratis_7_dias)+"\n    ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }